'use client';
import { useAdaptiveModalCustom } from '@sbercloud/uikit-product-mobile-modal';
import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import { Search as SearchSnack } from '@snack-uikit/search';
import { useMemo, useRef, useState } from 'react';

import { Condition, PlatformMultiSelect } from '@/components/static';
import { SearchResults } from '@/components/static/InitialSearch/SearchResults';
import { MIN_SEARCH_PHRASE_FOR_SEARCH } from '@/constant/serp';
import { useSearchArticles, useSERPFilters } from '@/hooks/serp';
import { useCurrentPlatform } from '@/hooks/useCurrentPlatform';
import { useFocus } from '@/hooks/useFocus';
import { useTimeout } from '@/hooks/useTimeout';
import { useLayoutType } from '@/root/src/hooks';
import { useServerDataCtx } from '@/root/src/hooks/ctx';
import { equals, isEmpty } from '@/utils/common';

import { SearchModalFooter } from './Footer';
import s from './styles.module.scss';

export function InitialSearch() {
  const currentPlatform = useCurrentPlatform();
  const [selectedPlatforms, setSelectedPlatforms] = useState<string[]>([currentPlatform]);
  const [search, setSearch] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const { docsData, isLoading: isLoadingSerpFilters } = useSERPFilters();
  const searchInputRef = useRef<HTMLInputElement | null>(null);

  const searchPayload = useMemo(
    () => ({ phrase: searchKeyword, platforms: selectedPlatforms, products: [] }),
    [searchKeyword, selectedPlatforms],
  );

  const { articles, isLoading, searchRequestID } = useSearchArticles(searchPayload);

  useFocus(searchInputRef);

  const updateSearchPhraseWithTimeout = useTimeout(setSearchKeyword, 500);

  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);

  const AdaptiveModalCustom = useAdaptiveModalCustom({ layoutType });

  const onSubmitInput = (inputValue: string) => {
    setSearchKeyword(inputValue);
  };

  const handleUpdateSearch = (str: string) => {
    setSearch(str);
    updateSearchPhraseWithTimeout(str);
  };

  const isValidKeyword = searchKeyword.length >= MIN_SEARCH_PHRASE_FOR_SEARCH;

  // const handleChoosePopularReq = (reqLabel: string) => {
  //   setSearch(reqLabel);
  //   setSearchKeyword(reqLabel);
  // };

  const platformsFromConfig = docsData?.filters.platforms || [];

  return (
    <>
      <AdaptiveModalCustom.Header title='Быстрый поиск' className={s.modal_header} />
      <div className={s.controls_wrapper}>
        <SearchSnack
          ref={searchInputRef}
          outline
          value={search}
          onChange={handleUpdateSearch}
          size='l'
          loading={isLoading}
          onSubmit={onSubmitInput}
        />
        <PlatformMultiSelect
          metaPlatforms={platformsFromConfig}
          isLoadingOptions={isLoadingSerpFilters}
          outerTriggerClassName={s.platforms_select}
          initSelectedOptions={selectedPlatforms}
          onSelect={setSelectedPlatforms}
        />
      </div>

      <AdaptiveModalCustom.Body
        className={s.modal_body}
        content={
          <div className={s.search_modal_wrapper}>
            {/*<Condition when={articles === null} otherwise={<SearchResults isLoading={isLoading} articles={articles} />}>*/}
            {/*  <PopularRequests onChoose={handleChoosePopularReq} />*/}
            {/*</Condition>*/}
            <Condition when={isValidKeyword}>
              <SearchResults
                isAllPlatformsSelected={equals(platformsFromConfig.length, selectedPlatforms.length)}
                selectedPlatforms={selectedPlatforms}
                isLoading={isLoading}
                articles={articles}
              />
            </Condition>
          </div>
        }
      />
      <Condition when={!isEmpty(articles) && isValidKeyword}>
        <AdaptiveModalCustom.Footer
          className={s.modal_footer}
          actions={
            <SearchModalFooter
              searchRequestID={searchRequestID}
              totalCount={articles?.length || 0}
              platforms={selectedPlatforms}
              searchKeyword={searchKeyword}
            />
          }
        />
      </Condition>
    </>
  );
}
